<template>
    <div class="home">
        <nav>
            <div class="logo">
                <img
                    src="@/assets/img/upmood_logo.svg"
                    @click="$router.push({name: 'dashboard'})"
                >
            </div>
            <ul>
                <li
                    v-for="({to, text, icon, children},index) in navLinks"
                    :key="index"
                >
                    <router-link
                        :to="to"
                        class="link"
                    >
                        <img
                            :src="icon"
                            class="icon"
                        >

                        {{ text }}

                    </router-link>

                    <ul v-if="children && $route.path.indexOf(to) > -1">
                        <li
                            v-for="({to, text, icon}, index) in children"
                            :key="index"
                        >
                            <router-link
                                :to="to"
                                class="sub-link"
                            >
                                <img
                                    :src="icon"
                                    class="icon"
                                >

                                {{ text }}
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>

        <main>
            <header>
                <div class="title-bar">
                    <h2>
                        {{ $route.meta.title }}
                    </h2>

                    <user-notification></user-notification>

                    <div class="avatar">

                        <img
                            src="@/assets/img/profile-avatar.png"
                            @click="showUserMenu = !showUserMenu"
                        >

                        <p v-if="showUserMenu" @click="logout()">
                            Logout
                        </p>
                    </div>
                </div>

                <div
                    class="breadcrumbs"
                    v-if="$route.meta.origin"
                >
                    <img
                        src="@/assets/icons/ic_home.svg"
                        class="icon"
                        @click="$router.push('/dashboard')"
                    >

                    <span
                        v-for="{name, text} in $route.meta.origin"
                        :key="name"
                        @click="$router.push({name: name})"
                    >
                        {{ text }}
                    </span>

                    <span>
                        {{ $route.meta.title }}
                    </span>
                </div>
            </header>

            <section class="main-section">
				<router-view class="view"></router-view>
            </section>
        </main>
    </div>
</template>

<script>
import UserNotification from '@/components/auth/UserNotification.vue'

export default {
	data () {
		return {
			showUserMenu: false,

			navLinks: [
				{ to: '/dashboard', text: 'Dashboard', icon: require('@/assets/icons/ic_dashboard.png') },
				{ to: '/users', text: 'Users', icon: require('@/assets/icons/ic_user.png') },
				{ to: '/messages', text: 'Messages', icon: require('@/assets/icons/ic_message.png') },
				// { to: '/stickers', text: 'Stickers', icon: require('@/assets/icons/ic_error.png') },
				{ to: '/orders', text: 'Orders', icon: require('@/assets/icons/ic_order.png') },
				{ to: '/notification-post', text: 'Notification', icon: require('@/assets/icons/ic_notification.png') }
				// { to: '/newsfeed-post',
				// 	text: 'Newsfeed',
				// 	icon: require('@/assets/icons/ic_error.png'),
				// 	children: [
				// 		{ to: '/newsfeed-post/main', text: 'Main', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/mid', text: 'Mid', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/subtags', text: 'Subtags', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/add-subtags', text: 'Add subtags', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/drafts', text: 'Drafts ', icon: require('@/assets/icons/ic_error.png') },
				// 		{ to: '/newsfeed-post/archives', text: 'Archives', icon: require('@/assets/icons/ic_error.png') }
				// 	]
				// }
			]
		}
	},

	methods: {
		logout () {
			this.$store.commit('LOG_OUT')
		}
	},

	components: {
		UserNotification
	}
}
</script>

<style lang="scss" scoped>
.home {
    height: 100%;
    width: 100%;
    display: flex;

    nav {
        background-color: $dark2;
        flex-shrink: 0;
        height: 100%;

        .logo {
            padding: 15px;

            img {
                width: 150px;
                cursor: pointer;
            }
        }

        ul {
            li {
                .link, .sub-link {
                    padding: 15px 10px;
                    width: 200px;
                    font-size: 16px;
                    color: $light1;
                    border-left: 3px solid transparent;
                    cursor: pointer;
                    transition: 0.3s;
                    @include flex-row(stretch, center);

                    .icon {
                        margin: 0 10px;
                        width: 20px;
                    }
                }

                .link {
                    &.router-link-active, &:hover {
                        border-color: $warning;
                        background-color: $dark3;
                    }
                }

                ul {
                    li {
                        background-color: lighten($dark3, 8%);

                        .sub-link {
                            padding-left: 25px;

                            &.router-link-active, &:hover {
                                background-color: $dark3;
                            }
                        }
                    }
                }

            }
        }
    }

    main {
        height: 100%;
        flex: 1 1 auto;
        @include flex-column(stretch, stretch);
        overflow: hidden;

        header {
            background-color: #fff;
            border-bottom: 1px solid $light;

            .title-bar {
                padding: 15px;
                @include flex-row(stretch, center);

                h2 {
                    flex: 1 1 auto;
                }

                .notif {
                    width: 40px;
                    padding: 10px;
                    margin-left: 30px;
                    cursor: pointer;
                    background-color: $light;
                    border-radius: 50%;
                }

                .avatar {
                    position: relative;

                    img {
                        border-radius: 50%;
                        width: 50px;
                        margin-left: 30px;
                        cursor: pointer;
                    }

                    p {
                        position: absolute;
                        top: 100%;
                        margin-top: 10px;
                        background-color: #fff;
                        padding: 10px 20px;
                        font-weight: 600;
                        color: $dark;
                        cursor: pointer;
                        border: 1px solid $light;
                        border-radius: 5px;
                        z-index: 999;

                        &:after {
                            position: absolute;
                            content: "";
                            right: 25px;
                            top: -6px;
                            border: 1px solid;
                            border-color: $light  $light transparent transparent;
                            display:inline-block;
                            height: 10px;
                            width: 10px;
                            background-color: #fff;
                            transform: rotateZ(-45deg);
                            pointer-events: none;
                            z-index: 999;
                        }

                        &:hover {
                            color: $primary;
                            border-color: $primary;

                            &:after {
                                border-color: $primary $primary transparent transparent;
                            }
                        }
                    }
                }
            }

            .breadcrumbs {
                background-color: $light1;
                color: $dark3;
                font-weight: 600;
                padding: 10px;

                .icon {
                    width: 15px;
                    cursor: pointer;
                }

                span {
                    cursor: pointer;
                    margin: 0 5px;

                    &:before {
                        content: '\003E';
                        display: inline-block;
                        font-size: 18px;
                        font-weight: 600;
                        line-height: 14px;
                        pointer-events: none;
                        cursor: default;
                        margin: 0 5px;
                    }
                }
            }
        }

        .main-section {
            height: 100%;
            flex: 1 1 auto;
            overflow: auto;
            background-color: $primary-light;

            .view {
                padding: 30px;
                min-width: 1080px;
                height: 100%;
                min-height: 600px;
                @include flex-column;
            }
        }
    }
}
</style>
